import { render, staticRenderFns } from "./dashboard_section.vue?vue&type=template&id=c20bcb2e&scoped=true&"
import script from "./dashboard_section.vue?vue&type=script&lang=js&"
export * from "./dashboard_section.vue?vue&type=script&lang=js&"
import style0 from "./dashboard_section.vue?vue&type=style&index=0&id=c20bcb2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20bcb2e",
  null
  
)

export default component.exports